<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<!-- Filter Panel -->
@if (isAdmin()) {
  <div class="filter-panel">
    <div class="filter-header">
      <div class="filter-title">
        <svg width="20" height="20" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z"
          />
        </svg>
        Package Filters
      </div>
      <div class="filter-actions">
        <div class="upload-container">
          <input
            #fileInput
            type="file"
            accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            (change)="onFileSelected($event)"
            style="display: none"
          />

          @if (!selectedFile()) {
            <button class="upload-btn" (click)="fileInput.click()">
              <svg width="16" height="16" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"
                />
              </svg>
              Import Packages
            </button>
          } @else {
            <div class="selected-file-actions">
              <span class="file-name" [title]="selectedFile()?.name">
                {{ selectedFile()?.name }}
              </span>
              <button
                type="button"
                class="confirm-upload-btn"
                (click)="uploadFile()"
                [disabled]="isUploading()"
              >
                @if (isUploading()) {
                  <span class="spinner"></span>
                  Uploading...
                } @else {
                  Confirm Import
                }
              </button>
              <button
                type="button"
                class="cancel-upload-btn"
                (click)="selectedFile.set(null)"
                [disabled]="isUploading()"
              >
                <svg width="14" height="14" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>
          }
        </div>

        <button class="add-package-btn" (click)="onAddPackage()">
          <svg width="16" height="16" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M12 6v6m0 0v6m0-6h6m-6 0H6"
            />
          </svg>
          Add Package
        </button>
      </div>
    </div>
  </div>
}

@if (!isLoading() && packages().length) {
  <div class="table-card">
    <div class="table-responsive">
      <table class="data-table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Price (฿)</th>
            <th>Start Date</th>
            <th>End Date</th>
            <th>Type</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          @for (pkg of packages(); track pkg._id) {
            <tr>
              <td>{{ pkg.name }}</td>
              <td>{{ pkg.price | number: '1.2-2' }}</td>
              <td>{{ pkg.startDate }}</td>
              <td>{{ pkg.expiryDate }}</td>
              <td>{{ pkg.packageType }}</td>
              <td>
                <div class="action-btns">
                  <button class="edit-btn" (click)="onEdit(pkg)">
                    <svg
                      width="18"
                      height="18"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                      />
                    </svg>
                  </button>
                  <button class="delete-btn" (click)="onDelete(pkg)">
                    <svg
                      width="18"
                      height="18"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                      />
                    </svg>
                  </button>
                </div>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>

    <app-pagination
      [totalItems]="totalItems()"
      [pageSize]="pageSize()"
      [currentPage]="currentPage()"
      itemName="packages"
      (pageChange)="onPageChange($event)"
      (pageSizeChange)="onPageSizeChange($event)"
    />
  </div>
}

@if (!isLoading() && !packages().length) {
  <app-data-not-found [message]="'No packages found'" />
}

@if (isLoading()) {
  <app-loader />
}

@if (isModalOpen()) {
  <div
    class="modal-backdrop"
    (click)="closeModal()"
    (keydown.escape)="closeModal()"
    role="button"
    tabindex="0"
  >
    <div class="modal-container" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h2 class="modal-title">{{ isEditMode() ? 'Edit Package' : 'Add New Package' }}</h2>
        <button class="close-modal-btn" (click)="closeModal()">
          <svg width="24" height="24" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
      </div>

      <div class="modal-body">
        <form [formGroup]="packageForm" (ngSubmit)="savePackage()">
          <div class="form-grid">
            <!-- Name Row -->
            <div class="form-group full-width">
              <label for="name">Name</label>
              <div class="input-wrapper">
                <input
                  id="name"
                  type="text"
                  formControlName="name"
                  placeholder="Name"
                  class="form-input"
                />
              </div>
            </div>

            <!-- Price Row -->
            <div class="form-group full-width">
              <label for="price">Price</label>
              <div class="input-wrapper">
                <input
                  id="price"
                  type="text"
                  formControlName="price"
                  placeholder="Price"
                  class="form-input"
                />
              </div>
            </div>

            <!-- Package Type -->
            <div class="form-group full-width">
              <label for="packageType">Package Type</label>
              <div class="input-wrapper">
                <select id="packageType" formControlName="packageType" class="form-input">
                  <option value="">Select Type</option>
                  <option [value]="'Delivered'">Delivered</option>
                  <option [value]="'Submit'">Submit</option>
                </select>
              </div>
            </div>

            <!-- Start Date -->
            <div class="form-group full-width">
              <label for="email">Start Date</label>
              <app-date-picker formControlName="startDate" placeholder="DD-MM-YYYY" />
            </div>

            <!-- Expiry Date -->
            <div class="form-group full-width">
              <label for="eSimCreditLimit">Expiry Date</label>
              <app-date-picker formControlName="expiryDate" placeholder="DD-MM-YYYY" />
            </div>
          </div>

          <div class="modal-footer">
            <button type="button" class="modal-btn cancel" (click)="closeModal()">Cancel</button>
            <button type="submit" class="modal-btn save" [disabled]="packageForm.invalid">
              {{ isEditMode() ? 'Update Package' : 'Save Package' }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
}

<!-- Delete Confirmation Modal -->
@if (isDeleteModalOpen()) {
  <div
    class="modal-backdrop"
    (click)="closeDeleteModal()"
    (keydown.escape)="closeDeleteModal()"
    role="button"
    tabindex="0"
  >
    <div class="modal-container delete-modal" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h2 class="modal-title">Confirm Deletion</h2>
        <button class="close-modal-btn" (click)="closeDeleteModal()">
          <svg width="24" height="24" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
      </div>

      <div class="modal-body text-center">
        <div class="delete-icon-wrapper">
          <svg width="48" height="48" fill="none" stroke="#ef4444" viewBox="0 0 24 24">
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
            />
          </svg>
        </div>
        <p class="delete-message">
          Are you sure you want to delete
          <strong>{{ packageToDelete()?.name }}</strong
          >? This action cannot be undone.
        </p>
      </div>

      <div class="modal-footer">
        <button type="button" class="modal-btn cancel" (click)="closeDeleteModal()">
          No, Keep it
        </button>
        <button type="button" class="modal-btn delete" (click)="confirmDelete()">
          Yes, Delete Package
        </button>
      </div>
    </div>
  </div>
}
